
        
            
            import * as React from "react";
            window['React'] = React;
        
            
            import * as ReactDOMRoot from "react-dom";
            window['ReactDOMRoot'] = ReactDOMRoot;
        
            
            import * as ReactDOMClient from "react-dom/client";
            window['ReactDOMClient'] = ReactDOMClient;
        
            
            import * as ReactUseWebsocket from "react-use-websocket";
            window['ReactUseWebsocket'] = ReactUseWebsocket;
        
            
            import * as Recharts from "recharts";
            window['Recharts'] = Recharts;
        
            
            import * as ReactRouter from "react-router";
            window['ReactRouter'] = ReactRouter;
        
            
            import * as ReactRouterDom from "react-router-dom";
            window['ReactRouterDom'] = ReactRouterDom;
        
            
            import * as html2canvas from "html2canvas";
            window['html2canvas'] = html2canvas;
        
            
            import * as RemixRouter from "@remix-run/router";
            window['RemixRouter'] = RemixRouter;
        
            
            import * as Joda from "@js-joda/core";
            window['Joda'] = Joda;
        
            
            import * as ReactFlipToolkit from "react-flip-toolkit";
            window['ReactFlipToolkit'] = ReactFlipToolkit;
        
            
            import * as Marked from "marked";
            window['Marked'] = Marked;
        
            
            import * as EmotionCss from "@emotion/css";
            window['EmotionCss'] = EmotionCss;
        
            
            import * as Fitty from "fitty";
            window['Fitty'] = Fitty;
        
            
            import * as DDWM from "drag-drop-webkit-mobile";
            window['DDWM'] = DDWM;
        
            
            import * as ReactJsxRuntime from "react/jsx-runtime";
            window['ReactJsxRuntime'] = ReactJsxRuntime;
        

        
            
        
    